import React from "react";
import { Outlet, useLocation, Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { findCard } from "@/pages/admin/adminCards";

// Admin Center is the single hub; each admin page gets a breadcrumb back to it.
export default function AdminLayout() {
  const { pathname } = useLocation();
  const hit = findCard(pathname);
  return (
    <div>
      {pathname !== "/admin/center" && (
        <nav aria-label="Breadcrumb" className="flex flex-wrap items-center gap-1 text-sm text-slate-500 mb-4" data-testid="admin-breadcrumb">
          <Link to="/admin/center" className="font-medium hover:text-[#006090]" data-testid="admin-back-to-center">Admin Center</Link>
          {hit && <><ChevronRight className="w-3.5 h-3.5" /><span>{hit.section}</span><ChevronRight className="w-3.5 h-3.5" />
            {hit.sub ? <><Link to={hit.cardTo} className="hover:text-[#006090]">{hit.card}</Link><ChevronRight className="w-3.5 h-3.5" /><span className="text-slate-700">{hit.sub}</span></>
              : <span className="text-slate-700">{hit.card}</span>}</>}
        </nav>
      )}
      <Outlet />
    </div>
  );
}
